import * as React from 'react';
import { DocumentationPage } from './DocumentationPage';

export const GeneralDocumentation: React.FC = () => (
    <DocumentationPage title='General Documentation' articleType='general'></DocumentationPage>  
);